<template>
  <div>
    <AddNumberPopup :isActive="isDetailsActive" @close="toggleDetails" />
    <b-card class="rounded-xl border-none">
      <div class="mb-4 flex justify-between">
        <h2 class="text-2xl font-semibold">Phonebook Number List</h2>
        <base-button outline type="success" @click="toggleDetails(true)"
          >Add Phone Number</base-button
        >
      </div>
      <div class="flex items-center cursor-pointer mb-8" @click="handleClick">
        <feather-icon icon="ChevronLeftIcon" class="mr-2"></feather-icon>
        <p class="font-semibold">Back</p>
      </div>
      <div class="mt-12">
        <b-input-group>
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="AddNumberData"
        >
          <el-table-column label="SNo" min-width="120px" prop="vid" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.vid }}</span>
            </template>
          </el-table-column>

          <el-table-column label=" Name" min-width="140px" prop="name" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Mobile No"
            min-width="200px"
            prop="mobileNo"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.mobileNo }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Email ID"
            min-width="140px"
            prop="emailID"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.emailID }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Action"
            min-width="100px"
            prop="action"
            sortable
          >
            <template>
              <div class="flex items-center">
                <div class="flex items-center cursor-pointer">
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-5"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Delete"
                  ></feather-icon>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination
            v-model="currentPage"
            :per-page="10"
            :total="50"
          ></base-pagination>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import AddNumberData from "./AddNumberData";
import AddNumberPopup from "./AddNumberPopup";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    AddNumberPopup,
  },
  data() {
    return {
      AddNumberData,
      currentPage: 1,
      isDetailsActive: false,
      isShowCreate: false,
    };
  },
  methods: {
    handleClick() {
      this.$router.push({ name: "group" });
    },
    toggleDetails(val = false) {
      this.isDetailsActive = val;
    },
  },
};
</script>
